<div class="bg-gray-900">
  <div class="ht-100v d-flex align-items-center justify-content-center">
    <div class="wd-lg-70p wd-xl-50p tx-center pd-x-40">
      <h1 class="tx-100 tx-xs-140 tx-normal tx-gray-300 mg-b-0">{{ statusCode || 'Error desconocido' }}!</h1>
      <h5 class="tx-xs-24 tx-normal tx-primary mg-b-30 lh-5">{{ errorTitle }}</h5>
      <p class="tx-16 tx-gray-300 mg-b-30">{{ errorDescription }}</p>
    </div>
  </div><!-- ht-100v -->
</div>
